export default __webpack_public_path__ + "./images/tg.0035a856.png";